import React, { useEffect, useState } from 'react';
import { withHousehold } from 'Context/HouseholdContext';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import GroupDisabilityInsurance from '../Sections/GroupDisabilityInsurance';
import GroupHealthInsurance from '../Sections/GroupHealthInsurance';
import GroupLifeInsurance from '../Sections/GroupLifeInsurance';
import LongTermCareInsurance from '../Sections/LongTermCareInsurance';
import MedicareInsurance from '../Sections/MedicareInsurance';
import PropertyInsurance from '../Sections/PropertyInsurance';
import PrivateDisabilityInsurance from '../Sections/PrivateDisabilityInsurance';
import PrivateHealthInsurance from '../Sections/PrivateHealthInsurance';
import PrivateLifeInsurance from '../Sections/PrivateLifeInsurance';
import Navigator from '../UI/Navigator';
import { getClientPicklistOptions } from '../Sections/Helpers/ClientPicklist';

const FamilyInformation = () => {
  const [insuredClientOptions, setInsuredClientOptions] = useState([]);
  const { householdResource } = useSimpleHousehold();

  useEffect(() => {
    setInsuredClientOptions(getClientPicklistOptions(householdResource));
  }, [householdResource]);

  return (
    <Navigator>
      <PropertyInsurance insuredClientOptions={insuredClientOptions} />
      <GroupHealthInsurance insuredClientOptions={insuredClientOptions} />
      <GroupDisabilityInsurance insuredClientOptions={insuredClientOptions} />
      <GroupLifeInsurance insuredClientOptions={insuredClientOptions} />
      <PrivateHealthInsurance insuredClientOptions={insuredClientOptions} />
      <MedicareInsurance insuredClientOptions={insuredClientOptions} />
      <PrivateDisabilityInsurance insuredClientOptions={insuredClientOptions} />
      <LongTermCareInsurance insuredClientOptions={insuredClientOptions} />
      <PrivateLifeInsurance insuredClientOptions={insuredClientOptions} />
    </Navigator>
  );
};

export default withHousehold(FamilyInformation);
